import { AfterViewInit, Component, OnInit, ViewChild, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatStepper } from "@angular/material/stepper";
import { DatabaseService } from "src/app/servicios/database/database.service";
import { FsessionService } from "src/app/servicios/session/fsession.service";

import { MessageService } from "src/app/servicios/message/message.service";
import { TranslateService } from "@ngx-translate/core";
import { groupBy } from "lodash";
import { HttpClient } from "@angular/common/http";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { CommonModule, KeyValuePipe, TitleCasePipe } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { HtmlEditorComponent } from "../../html-editor/html-editor.component";
import { HasPermissionDirective } from "src/app/servicios/permissions/hasPermission.directive";
import { MatSidenavModule } from "@angular/material/sidenav";

@Component({
  selector: "app-dialogo-leer-ayudas",
  templateUrl: "./dialogo-leer-ayudas.component.html",
  styleUrl: "./dialogo-leer-ayudas.component.scss",
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatStepperModule,
    MatTooltipModule,
    TranslateModule,
    HtmlEditorComponent,
    HasPermissionDirective,
    ReactiveFormsModule,
    KeyValuePipe,
    TitleCasePipe,
  ]
})
export class DialogoLeerAyudasComponent implements OnInit, AfterViewInit {
  private dialogRef = inject<MatDialogRef<DialogoLeerAyudasComponent>>(MatDialogRef);
  private fse = inject(FsessionService);
  private translateService = inject(TranslateService);
  private databaseService = inject(DatabaseService);
  private messageService = inject(MessageService);
  private http = inject(HttpClient);

  @ViewChild("stepper") stepper: MatStepper;

  public formControlEditing = new FormControl();

  public ayudas: Record<string, any[]>;
  public variables;

  public expandedDialog = false;
  public isReadOnly = true;

  public editingIndex = 0;
  public ayudasLength = 0;
  public currentHelp: any;

  constructor() {
    const data = inject<{
    pages: any;
    length: number;
}>(MAT_DIALOG_DATA);

    this.ayudas = groupBy(
      data.pages.map(ayuda => {
        return {
          ...ayuda,
          title: this.extractHelpTitle(ayuda)
        }
      })
      
      , 'submodulo');
    
    this.ayudasLength = data.length;
  }

  ngOnInit(): void {
    this.formControlEditing.disable();
    
    this.translateService
      .get(["operacionExitosa", "mensaje_confirmacion"])
      .subscribe((translations) => (this.variables = translations));
  }

  ngAfterViewInit(): void {
    const firstPage = this.ayudas[Object.keys(this.ayudas)[0]][0];

    this.currentHelp = firstPage;

    this.stepper.selectionChange.subscribe((changed) => {
      const [submodulo, idAyuda] = changed.selectedStep.label.split(',');
      const ayudaActual = this.ayudas[submodulo].find(ayuda => ayuda.idAyuda == idAyuda)

      if (ayudaActual) {
        this.currentHelp = ayudaActual;
        this.formControlEditing.setValue(ayudaActual.html);
      }
    });
  }

  extractHelpTitle(ayuda) {
    const regex = /<h2.*?>(.*?)<\/h2>/;
    const title = ayuda.html && ayuda.html.match(regex);

    if (title) {
      const innerHtml = title[1];
      return  innerHtml.replace(/<.*?>/g, '');
    }
    
    return ayuda.submodulo;
  }

  navigateTo(idAyuda) {
    let stepIndex;

    const helpStep = this.stepper.steps.find((step, index) => {
      const labelInfo = step.label.split(',');
      if (labelInfo[1] == idAyuda) {
        stepIndex = index;
        return true;
      }

      return false;
    });
    
    this.currentHelp = helpStep;
    
    this.stepper.selectedIndex = stepIndex;
  }

  /**
   * Cambia el editor a modo escritura con todas las herramientas
   */
  setEditMode() {
    const help = this.currentHelp;

    this.isReadOnly = !this.isReadOnly;

    if (this.isReadOnly) {
      this.formControlEditing.disable();
      this.formControlEditing.setValue(help.html);
    } else {
      this.formControlEditing.enable();
    }
  }

  /**
   * Expande el diálogo para que ocupe toda la pantalla
   */
  expandDialog() {
    this.expandedDialog = !this.expandedDialog;

    let dialogSetting;

    if (this.expandedDialog) {
      dialogSetting = {
        width: "100vw",
        height: "100vh",
      };
    } else {
      dialogSetting = {
        width: "75%",
        height: "80%",
      };
    }

    this.dialogRef.updateSize(dialogSetting.width, dialogSetting.height);
  }

  saveChanges() {
    const help = this.currentHelp;

    this.databaseService
      .modificarAyudaLenguage({
        lang: this.fse.optenerValor("language") ?? "es",
        IdSumoduloPermisoAyuda: help.idAyuda,
        html: this.formControlEditing.value,
      })
      .subscribe({
        next: () => {
          help.html = this.formControlEditing.value;
          help.title = this.extractHelpTitle(help);

          this.messageService
            .SwalMessage("success", this.variables["mensaje_confirmacion"], false, 2000)
            .then(() => {
              this.setEditMode();
            });
        },
        error: () => {
          this.messageService.SwalMessage("error", this.variables["haOcurridoUnError"]);
        },
      });
  }

}
